import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

// import redux from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions';


import _ from "lodash";
import PrivateRoute from 'react-private-route';

import Loading from './Loading';
import Landing from './Frontend/Landing';
import Login from './Frontend/Login/Login';
import Dashboard from './Backend/Dashboard/Dashboard';
import CreateBadgeClass from './Backend/CreateBadge/CreateBadge';
import CreateAssertion from './Backend/CreateAssertion/CreateAssertion';
import ImportAssertions from './Backend/ImportAssertions/ImportAssertions';

import EditAssertion from './Backend/EditAssertion/EditAssertion';
import EditBadgeClass from './Backend/EditBadgeClass/EditBadgeClass';
import Assertion from './Frontend/Assertion/Assertion';
import BadgeClass from './Frontend/BadgeClass/BadgeClass';
// import classes from 'cssClasses';

class App extends Component {
	constructor(props){
		super(props);

		this.isAuth = this.isAuth.bind(this);
	}

	componentDidMount() {
		this.props.fetchUser();
	}

	isAuth(roles){
    if (this.props.auth === null){
			return false
    }else if(this.props.auth === false ) {
			return false
    }else{
      const checkRoles = _.filter(roles,(role) => this.props.auth.roles.indexOf(role) >= 0).length > 0;
      if (checkRoles === false){
				return false
      }
    }
		return true;
	}

	render(){
		if (this.props.auth === null){
			return <Loading />;
		}
		return (
			<div>
				<BrowserRouter>
					<div>

						<PrivateRoute exact path="/admin/badgeclasses"  pathname="/" component={CreateBadgeClass} isAuthenticated={this.isAuth(['administrator'])}  />
						<PrivateRoute exact path="/admin/badgeclasses/:id" component={EditBadgeClass} isAuthenticated={this.isAuth(['administrator'])} />
						<PrivateRoute exact path="/admin/badgeclasses/:id/import-assertions"  pathname="/" component={ImportAssertions} isAuthenticated={this.isAuth(['administrator'])}  />
						<PrivateRoute exact path="/admin/badgeclasses/:id/assertion"  pathname="/" component={CreateAssertion} isAuthenticated={this.isAuth(['administrator'])}  />
						<PrivateRoute exact path="/admin/badgeclasses/:badgeId/assertions/:id"  pathname="/" component={EditAssertion} isAuthenticated={this.isAuth(['administrator'])}  />
						<PrivateRoute exact path="/admin" component={Dashboard} isAuthenticated={this.isAuth(['administrator'])} />
						<Route exact path="/" component={Landing} />
						<Route exact path="/login" component={Login} />
						<Route exact path="/badgeclasses/:id" component={BadgeClass} />
						<Route exact path="/badgeclasses/:badgeId/assertion/:id" component={Assertion} />
						{/*<route exact path="/surveys" component={dashboard} />
						<Route exact path="/surveys/new" component={Dashboard} />*/}
					</div>
				</BrowserRouter>
			</div>
		);
	}
}

const mapStateToProps = ({auth}) => ({auth});

export default connect(mapStateToProps,actions)(App);


// WEBPACK FOOTER //
// ./src/components/App.js